var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeDeclined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.78,
    height: 27.204,
    viewBox: "0 0 26.78 27.204",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12492",
    "data-name": "Group 12492",
    transform: "translate(-1495.9 -806.547)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12491",
    "data-name": "Group 12491"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37776",
    "data-name": "Path 37776",
    d: "M4.271,211.1a.543.543,0,0,0,.546.546H19.484a4.5,4.5,0,0,1-.027-.546,6.343,6.343,0,0,1,4.987-6.193,11.124,11.124,0,0,0-4.965-4.016,7.091,7.091,0,0,1-8.348-.011A11.059,11.059,0,0,0,4.271,211.1Z",
    transform: "translate(1491.629 617.477)",
    fill: "#e65b66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37777",
    "data-name": "Path 37777",
    d: "M101.349,6.04A6.043,6.043,0,1,0,95.3,12.086,6.051,6.051,0,0,0,101.349,6.04Z",
    transform: "translate(1411.633 806.547)",
    fill: "#e65b66"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2662",
    "data-name": "Ellipse 2662",
    cx: 5.252,
    cy: 5.252,
    r: 5.252,
    transform: "translate(1512.176 823.246)",
    fill: "#e65b66"
  })), /*#__PURE__*/React.createElement("path", {
    id: "close",
    d: "M2.455,2.211,4.071.595a.269.269,0,0,0-.38-.38L2.075,1.831.459.215a.269.269,0,0,0-.38.38L1.695,2.211.079,3.827a.269.269,0,1,0,.38.38L2.075,2.591,3.691,4.207a.269.269,0,0,0,.38-.38Zm0,0",
    transform: "translate(1515.223 826.158)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.44
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeDeclined);
export default __webpack_public_path__ + "static/media/DE-Declined.6b7cbf39.svg";
export { ForwardRef as ReactComponent };